"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
const defaultRanges = {
  昨天: [(0, _moment.default)().add(-1, 'day'), (0, _moment.default)().add(-1, 'day')],
  近7天: [(0, _moment.default)().add(-6, 'day'), (0, _moment.default)()],
  本月: [(0, _moment.default)().startOf('month'), (0, _moment.default)().endOf('month')],
  上个月: [(0, _moment.default)().add(-1, 'month').startOf('month'), (0, _moment.default)().add(-1, 'month').endOf('month')],
  近3个月: [(0, _moment.default)().add(-2, 'month').startOf('month'), (0, _moment.default)().endOf('month')]
};
var _default = exports.default = {
  name: 'YsDateRangePicker',
  props: {
    value: {
      type: Array,
      default: undefined
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    valueFormat: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showTime: {
      type: Boolean,
      default: false
    },
    /**
     * 可选范围，单位：毫秒
     */
    range: {
      type: Number,
      default: undefined
    },
    events: {
      type: Object,
      default: () => ({})
    },
    quickPicker: {
      type: Object | Boolean,
      default: () => defaultRanges
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    dropdownClassName: {
      type: String
    }
  },
  data() {
    return {
      calendarValue: []
    };
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        const [start, end] = value;
        if (this.valueFormat || !start && !end) {
          this.$emit('input', value);
          this.$emit('change', value);
          return;
        }
        this.$emit('input', [(0, _moment.default)(start).startOf('day').format('YYYY-MM-DD 00:00:00'), (0, _moment.default)(end).endOf('day').format('YYYY-MM-DD 23:59:59')]);
        this.$emit('change', [(0, _moment.default)(start).startOf('day').format('YYYY-MM-DD 00:00:00'), (0, _moment.default)(end).endOf('day').format('YYYY-MM-DD 23:59:59')]);
      }
    },
    renderRanges() {
      if (typeof this.quickPicker === 'boolean') {
        return this.quickPicker ? defaultRanges : undefined;
      }
      return this.quickPicker;
    }
  },
  methods: {
    handleCalendarChange(dates) {
      this.calendarValue = dates;
    },
    disabledDate(date) {
      if (!this.range) {
        return false;
      }
      const [start, end] = this.calendarValue;
      if (start && end || !start && !end) {
        return false;
      }
      return (0, _moment.default)(date).valueOf() - (0, _moment.default)(start).valueOf() > this.range || (0, _moment.default)(start).valueOf() - (0, _moment.default)(date).valueOf() > this.range;
    }
  }
};